//todo: find a solution to hide show game or 1px?
//could use custom scaler on canvas
//pause on exit UI called from out side this code
//speed core passed in own parameter but need to be grouped with userdata for cards and background or userdata can be put into speed core model
//could destroy full canvas on each load...

import { CANVAS,AUTO,Scale,Game } from 'phaser';
import SpeedUI from "./SpeedUI.js";
export default class GameUI {
    constructor(parent, audio, quality, useCanvas, mute) {

        this.game = null;
        this.gameUI = null;
        this.gameScene = null;
        this.gameWidth = 500;
        this.gameHeight = 800;
        this.maxWidth = 720;//1080;
        this.maxHeight = 1280; //1620;

        this.settings(parent, audio, quality, useCanvas, mute);
    }
    settings(parent, audio, quality, useCanvas, mute){
        this.audio = audio;
        this.quality = quality;
        this.useCanvas = useCanvas;
        this.mute = mute;
        this.parent = parent;
        if (!parent) this.parent = "Game";
    }
    create(data) {
        let parent = this.parent;
        let width = this.getGameSize().width; //1080
        let height = this.getGameSize().height;//1620;
        let useCanvas = this.useCanvas;
        let mute = this.mute;
        const audio = this.audio;
        //let width = 1080;
        //let height = 1620;

        const config = {
            title: "Speed",
            parent: parent,
            xbackgroundColor: "#18216D",
            audio: {
                noAudio: true
            },
            type: useCanvas ? CANVAS : AUTO,
            scale: {
                mode: Scale.NONE, // we will resize the game with our own code (see Boot.js)
                width: width, // set game width by multiplying window width with devicePixelRatio
                height: height, // set game height by multiplying window height with devicePixelRatio
                autoRound: true
            },
            // scale: {
            //     mode: Phaser.Scale.FIT,
            //     autoCenter: Phaser.Scale.CENTER_BOTH,
            //     width: width,
            //     height: height,
            // },
            render: {
                antialias: true,
                transparent: true,
                roundPixels: true,
            },
        };
        this.gameUI = new Game(config);
        this.gameScene = new SpeedUI(audio);
        this.gameUI.scene.add('Speed', this.gameScene, true, data);

        // this.gameUI.events.on('hidden', function () {
        //     console.log('hidden');
        // }, this);

        // this.gameUI.events.on('visible', function () {
        //     console.log('visible');
        // }, this);

        window.addEventListener('resize', () => {
            this.resize();
        });

        //  window.addEventListener('orientationchange', () => {
        //     this.resize();
        // });

        this.resize();
    }
    startGame(data) {
        //this.game = data.speed;
        this.show();
        if (!this.gameUI) {
            this.create(data);
        }

        else if(this.gameScene && this.gameScene.scene) {
            this.gameScene.scene.restart(data);
            //this.gameScene.scene.resume();
        }
        let mute = this.mute;
        this.gameUI.sound.mute = mute;
        this.resize();
    }
    show() {
        if (this.game) {
            //this.game.resume();
        }
        // if (this.gameUI) {
        //     this.gameUI.canvas.style.display = "block";
        //     this.gameUI.scene.resume('Speed');
        // }
        if (this.gameScene && this.gameScene.scene) {
            this.gameScene.scene.resume();
        }
        // if (this.gameUI) {
        //     this.gameUI.canvas.style.display = "block";
        // }
        // let parent = document.getElementById(this.parent);
        // if (parent) {
        //     parent.style.display = "block";
        //     //parent.style.width = "100%";
        //     //parent.style.height = "100%";
        // }
    }
    hide() {

        if (this.game) {
            //this.game.pause();
            //this.game.destroy();
        }
        if (this.gameUI) {
            this.gameUI.canvas.style.display = "none";
        }
        if (this.gameScene && this.gameScene.scene) {
            this.gameScene.scene.pause();
        }
        let parent = document.getElementById(this.parent);
        if (parent) {
            //parent.classList.remove("showGame");
            //parent.classList.add("hideGame");
            parent.style.display = "none";
            //parent.style.width = "1px";
            //parent.style.height = "1px";
        }
        // if (this.gameUI) {
        //     this.gameUI.canvas.style.display = "none";
        //     this.gameUI.scene.pause('Speed');
        // }

        //this.destroy();
    }
    destroy() {
        if (this.game) {
            this.game.destroy();
        }
        if (this.gameUI) {
            this.gameUI.destroy(true);
            this.gameUI = null;
        }
    }
    resize(quality) {
        if (!this.gameUI) return;
        const canvasParent = document.getElementById(this.parent);

        const gameSize = this.getGameSize(quality, canvasParent);

        const canvasSize = this.getCanvasSize(gameSize.width, gameSize.height, canvasParent);
        const canvas = this.gameUI.canvas
        canvas.style.width = canvasSize.width + 'px';
        canvas.style.height = canvasSize.height + 'px';
        canvas.style.marginLeft = canvasSize.marginLeft + 'px';
        canvas.style.marginTop = canvasSize.marginTop + 'px';

        //needs to be after canvas resize or touch does not work
        this.gameUI.scale.setGameSize(gameSize.width, gameSize.height);
        console.log("resize", gameSize);
    }
    getGameSize(quality, parent, devicePixelRatio) {
        //scale the game size (canvas pixels) to increase quailty or performance based on screen size.
        if (!parent) parent = window.screen;
        if (!devicePixelRatio) devicePixelRatio = window.devicePixelRatio || 1;


        const parentWidth = (parent.innerWidth || parent.clientWidth || parent.width);
        const parentHeight = (parent.innerHeight || parent.clientHeight || parent.height);
        let maxWidth = this.maxWidth;
        let maxHeight = this.maxHeight;
        const gameWidth = this.gameWidth;
        const gameHeight = this.gameHeight;
        const screenWidth = parentWidth * devicePixelRatio;
        const screenHeight = parentHeight * devicePixelRatio;
        //const screenWidth = window.innerWidth * devicePixelRatio;
        //const screenHeight = window.innerHeight  * devicePixelRatio;

        if (!quality) quality = this.quality;
        //auto set quality
        if (!quality) quality = this.getQuality(screenWidth, screenHeight, devicePixelRatio);
        if (quality == "low") maxWidth = 360;
        if (quality == "medium") maxWidth = 500;
        if (quality == "high") maxWidth = 720;
        if (quality == "ultra") maxWidth = 1080;
        //let qualityScale = 1.0;

        //if the screen is smaller, the it as max width
        maxWidth = Math.min(screenWidth, maxWidth);
        maxHeight = Math.min(screenHeight, maxHeight);
        const scaleX = maxWidth / gameWidth;
        const scaleY = maxHeight / gameHeight;
        const scale = Math.min(scaleX, scaleY);
        const newWidth = gameWidth * scale; //const newWidth = gameWidth * scale * qualityScale;
        const newHeight = gameHeight * scale; //const newHeight = gameHeight * scale * qualityScale;
        return { width: newWidth, height: newHeight };

        //const actualFps = this.gameUI.loop.actualFps;
        //console.log("actualFps", actualFps);
    }
    getQuality(screenWidth, screenHeight, devicePixelRatio) {
        if (devicePixelRatio == 1) return "high"; //desktop
        if (screenWidth < 720) return "low";
        if (screenWidth < 1080) return "medium";
        return "high";
    }
    getCanvasSize(width, height, parent) {
        //size the canvas (canvas width and height) to fit to screen and center
        if (!parent) parent = window;

        const parentWidth = (parent.innerWidth || parent.clientWidth || parent.width);
        const parentHeight = (parent.innerHeight || parent.clientHeight || parent.height);
        const maxWidth = parentWidth;
        const maxHeight = parentHeight;
        const scaleX = maxWidth / width;
        const scaleY = maxHeight / height;
        const scale = Math.min(scaleX, scaleY);
        const newWidth = width * scale;
        const newHeight = height * scale;
        const marginLeft = (maxWidth - newWidth) / 2;
        const marginTop = (maxHeight - newHeight) / 2;

        return { width: Math.round(newWidth), height: Math.round(newHeight), marginLeft: Math.round(marginLeft), marginTop: Math.round(marginTop) };
    }




}


